/**
 * Created by dev on 10-02-16.
 */
define('autoLoginController',[
    'module',
    'underscore',
    'app',
    'settings'
], function(
    module, _, App, Settings
    ) {
    'use strict';

    var AutoLoginController = {
        autoLogin: function(userSecId, tokenId){
            Settings.set('currentUser', null);
            Settings.set('currentUserCookie', null);
            Settings.set('currentCAccountCookie', null);
            Settings.set('currentCAccount', null);
            Settings.set('tokenId', tokenId);
            require(['entities/session'], _.bind(function() {
                var getUser = App.request(
                        'session:userByToken',
                        {tokenId: tokenId, userSecId: userSecId}
                    );

                $.when(getUser).done(_.bind(function(response) {
                    Settings.set('currentUserCookie', JSON.stringify(response));
                    Settings.set('currentUser', response);
                    App.trigger('caccounts:list');
                }, this));
            }, this));
        }
    };

    module.exports = AutoLoginController;
});
